import { EventFrom } from 'xstate';

import assertEventType from 'common/bento/lib/assertEventType';
import { apolloClient } from 'common/graphql/clients';
import { SendProofOfFundsDocument } from 'features/Onboarding/modules/CapitalDepositProofOfFunds/graphql/mutations/sendProofOfFunds.gql';

import { MachineServices } from '../../../../../common/bento/types/MachineConfig';
import { DeleteProofOfFundsDocument } from '../graphql/mutations/deleteProofOfFunds.gql';
import { CapitalDepositProofOfFundsDocument } from '../graphql/queries/CapitalDepositProofOfFunds.gql';
import model, { Context, Model } from './model';

export enum Service {
  DeleteDocument = 'deleteDocument',
  SendDocument = 'sendDocument',
}

const services: MachineServices<Model, Service> = {
  deleteDocument: async (
    { getModuleData }: Context,
    event: EventFrom<typeof model>,
  ) => {
    assertEventType(event, 'DELETE_DOCUMENT');

    const { company } = getModuleData().proofOfFundsData.viewer;

    return apolloClient.mutate({
      awaitRefetchQueries: true,
      mutation: DeleteProofOfFundsDocument,
      refetchQueries: [
        {
          query: CapitalDepositProofOfFundsDocument,
          variables: {
            companyProfileId: company.companyProfileId,
          },
        },
      ],
      variables: {
        input: {
          kybDocumentId: event.data,
        },
      },
    });
  },

  sendDocument: async ({ documentFile, getModuleData }: Context) => {
    if (!documentFile) {
      throw new Error(
        `Can't call sendDocumentInformation without a document in context`,
      );
    }

    const { company } = getModuleData().proofOfFundsData.viewer;
    const { firebaseBucket, firebaseRef, type } = documentFile;

    return apolloClient.mutate({
      awaitRefetchQueries: true,
      mutation: SendProofOfFundsDocument,
      refetchQueries: [
        {
          query: CapitalDepositProofOfFundsDocument,
          variables: {
            companyProfileId: company.companyProfileId,
          },
        },
      ],
      variables: {
        input: {
          companyProfileId: company.companyProfileId,
          firebaseBucket,
          firebaseRef,
          type,
        },
      },
    });
  },
};

export default services;
